/*
 *
 * Script for mobile navigation (hamburger)
 *
 */

function disableScrolling() {
    document.documentElement.classList.add("--scroll-disabled");
}

function enableScrolling() {
    document.documentElement.classList.remove("--scroll-disabled");
}

export const navMobile = () => {
    const hamburger = document.querySelector(".header__hamburger");
    const menu = document.querySelector(".header__nav");
    const header = document.querySelector("header");
    const header_nav = document.querySelector(".header");

    if (hamburger) {
        hamburger.addEventListener("click", (e) => {
            menu.classList.toggle("--open");
            hamburger.classList.toggle("--open");
            if(header && header_nav && window.scrollY <= 142) {
                header.classList.toggle("--scrolled");
                header_nav.classList.toggle("--scrolled");
            }

            if (menu.classList.contains("--open")) {
                disableScrolling();
            } else {
                enableScrolling();
            }
        });
    }
    if (menu) {
        menu.addEventListener("click", (e) => {
            if (
                e.target.tagName.toLowerCase() == "a" &&
                window.getComputedStyle(hamburger, null).display !== "none"
            ) {
                // close menu after click link(for # purpose)

                menu.classList.toggle("--open");
                hamburger.classList.toggle("--open");
                if(header && header_nav && window.scrollY <= 142) {
                    header.classList.toggle("--scrolled");
                    header_nav.classList.toggle("--scrolled");
                }
                if (menu.classList.contains("--open")) {
                    disableScrolling();
                } else {
                    enableScrolling();
                }
            }
        });
    }

    const wpmlUl = document.querySelector('.wpml-ls > ul');
    if (wpmlUl && hamburger) {
        wpmlUl.addEventListener('click', function (e) {
            if (window.getComputedStyle(hamburger, null).display !== "none") {
                e.stopPropagation();
                wpmlUl.classList.toggle('open');
            }

        });

        document.addEventListener('click', function (e) {
            if (!wpmlUl.contains(e.target) && window.getComputedStyle(hamburger, null).display !== "none") {
                wpmlUl.classList.remove('open');
            }
        });

    }
    

};
